import { gnov as g } from '../../utils';

/**
 * Get nested object value
 *
 * @param data data object from which data will be obtained
 * @param path path of the information we're goint to get
 * @returns
 */
function gnov(data: any, path: string) {
  if (data && path) {
    return g(data, path);
  }
  return undefined;
}

export default gnov;
